<template lang="html">
  <div class="ui main container">
    <h2 class="ui  header">
      Reseñas
      <button
        class="ui right floated tiny basic primary button"
        type="button"
        name="button"
        v-if="isAuthenticated"
        @click="toggleDialog"
      >
        Deja tu reseña
      </button>
    </h2>
    <p class="">
      Aquí encontrarás las reseñas de nucestros clientes
    </p>
    <br />
    <div class="ui three stackable cards">
      <div
        class="ui card"
        v-for="(item, index) in reviews"
        :key="'review' + index"
      >
        <div class="content">
          <div class="header">{{ item.title }}</div>
          <div class="meta">
            <span class="right floated time"
              ><sui-rating icon="star" :rating="item.rate" :max-rating="5"
            /></span>
            <span class="category">{{ item.category }}</span>
          </div>
          <div class="description">
            <p>
              {{ item.review }}
            </p>
          </div>
        </div>
        <div class="extra content">
          <div class="left floated">
            {{ item.author ? item.author.name : 'Anonimo' }}
          </div>
          <div class="right floated">
            {{ item.createdOn | moment('from') }}
          </div>
        </div>
      </div>
    </div>
    <sui-modal v-model="open" size="tiny">
      <sui-modal-header>Agregar Reseña</sui-modal-header>
      <sui-modal-content>
        <sui-modal-description>
          <form class="ui big form">
            <div
              class="field required"
              :class="{ error: $v.review.title.$error }"
            >
              <label>Titulo</label>
              <div class="ui input">
                <input
                  type="text"
                  placeholder="Recomendado, excelente servicio, etc"
                  v-model.trim="$v.review.title.$model"
                />
              </div>
            </div>
            <div
              class="field required"
              :class="{ error: $v.review.category.$error }"
            >
              <label>Categoría</label>
              <div class="ui input">
                <input
                  type="text"
                  placeholder="¿Que compraste?"
                  v-model.trim="$v.review.category.$model"
                />
              </div>
            </div>

            <div
              class="field required"
              :class="{ error: $v.review.review.$error }"
            >
              <label>Tu reseña</label>
              <textarea
                rows="4"
                placeholder="Escribe tu reseña"
                v-model.trim="$v.review.review.$model"
              ></textarea>
            </div>
            <div
              class="field required"
              :class="{ error: $v.review.rate.$error }"
            >
              <label>Califica nuestro servicio</label>
              <span>
                <sui-rating
                  icon="star"
                  :rating="review.rate"
                  :max-rating="5"
                  @rate="handleRate"
                />
              </span>
            </div>
          </form>
        </sui-modal-description>
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button @click="toggleDialog">
          Cancelar
        </sui-button>
        <sui-button primary @click="save" :class="{ disabled: $v.$invalid }">
          Guardar
        </sui-button>
      </sui-modal-actions>
    </sui-modal>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators';

export default {
  name: 'ReviewPage',
  data: function() {
    return {
      open: false,
      review: {
        title: '',
        rate: 1,
        review: '',
        category: '',
        author: ''
      },
      coolors: [{ background: '#E7E6F7', foreground: '#f0f0f0' }]
    };
  },
  validations: function() {
    return {
      review: {
        title: { required },
        category: { required },
        review: { required },
        rate: { required }
      }
    };
  },
  created: async function() {
    await this.$store.dispatch('reviews/load');
  },
  computed: {
    reviews: function() {
      return this.$store.getters['reviews/getReviews'];
    },
    customerId: function() {
      return this.$store.getters['auth/getCustomerId'];
    },
    isAuthenticated: function() {
      return this.$store.getters['auth/isAuthenticated'];
    }
  },
  methods: {
    reset: function() {
      this.review = {
        title: '',
        rate: 1,
        review: '',
        category: '',
        author: ''
      };
      this.$v.review.$reset();
    },
    toggleDialog: function() {
      this.open = !this.open;
      this.reset();
    },
    handleRate(evt, props) {
      this.review.rate = props.rating;
    },
    save: async function() {
      this.review.author = this.customerId;

      const resp = await this.$store.dispatch('reviews/save', this.review);
      await this.$store.dispatch('reviews/load');
      this.toggleDialog();
    }
  }
};
</script>

<style lang="css" scoped></style>
